import { render, staticRenderFns } from "./SettingsAppearance.vue?vue&type=template&id=b584e0fa&scoped=true&"
import script from "./SettingsAppearance.vue?vue&type=script&lang=js&"
export * from "./SettingsAppearance.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAppearance.vue?vue&type=style&index=0&id=b584e0fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b584e0fa",
  null
  
)

export default component.exports